import { TUser } from '../../types/user';
import { createNoopReducer } from '../../utils/redux/createNoopReducer';

export const INITIAL_STATE: TUser = {
  isAuthenticated: false,
};

export const userReducer = createNoopReducer<TUser>(INITIAL_STATE);
